import { useState } from 'react';
import { useAuth } from 'utils/AuthProvider';
import {
  INotification,
  NotificationTypesCallback,
} from '../../services/notifications/types';

import { createEncyptedParams } from 'Components/Pagination/useWindowQueryParams';

const firstOrUndefined: <T>(t?: T[]) => T | undefined = (list) => {
  return list && list.length > 0 ? list[0] : undefined;
};

export const NotificationRoutes: NotificationTypesCallback<string> = {
  // client notifications
  client_task_share: (n) => `/tasks/${n.notification.notifiable_id}/details`,

  client_task_status_change: (n) => ``,

  client_tax_return_status_change: (n) =>
    `/questionnaires/${n.notification.notifiable_id}`,

  accountant_task_assign: (n) =>
    `/tasks/${n.notification.body?.task_id}/details`,

  accountant_tax_return_assign: (n) =>
    `/taxReturns/${n.notification.body?.project_id}/details`,

  admin_ticket_create: (n) => `/tickets/${n.notification.notifiable_id}`,

  admin_order_create: (n) => `/clients/${n.notification.actor.id}/Services`,

  admin_tax_return_submit: (n) =>
    `/taxReturns/${n.notification.notifiable_id}/details`,

  admin_accountant_sms_receive: (n) =>
    `/clients/${n.notification.actor.id}/SMS`,

  accountant_client_ticket_status_change: (n) => ``,

  accountant_client_signup: (n, user, role) =>
    role?.isClient
      ? `/profile/account/edit`
      : `/accountant/${n.notification.notifiable_id}/profileInfo`,

  client_order_item_cancel: (n) => `/services`,

  tax_fees_request_submit: (n) =>
    `/taxEstimates/${n.notification.notifiable_id}`,

  tax_extensions_request_submit: (n) =>
    `/taxExtensions/${n.notification.notifiable_id}`,
  fincen_report_request_submit: (n) =>
    `fincenReports/${n.notification.notifiable_id}`,

  document_upload: (n, user, role) => {
    const node = n.notification?.body?.file_object;

    const params = createEncyptedParams({
      per_page: 20,
      page: 1,
      filters: {
        id: node?.parent_id || undefined,
        task_id: node?.task_id || undefined,
        porject_id: firstOrUndefined(node?.project_ids),
        client_id: node?.client_id || undefined,
        business_id: node?.business_id || undefined,
      },
    });
    let url = `/documents?${params.toString()}`;
    if (node && !role?.isClient) {
      if (node.task_id) {
        url = `/tasks/${node.task_id}${url}`;
      } else if (node.project_ids && node.project_ids.length > 0) {
        url = `/taxReturns/${node.project_ids[0]}${url}`;
      } else if (node.client_id) {
        url = `/clients/${node.client_id}${url}`;
      }
    }

    // console.log({
    //   url,
    //   params: decryptQueryParams(params),
    //   _: params.toString(),
    // });
    return url;
  },
};

export function useNotificationRoute(n: INotification) {
  const { dashboard, user, userRole } = useAuth();
  const [url] = useState(() => {
    const builder = NotificationRoutes[n.notification.type];
    const url = builder && builder(n, user, userRole);
    if (url) return dashboard + url;
  });

  return url;
}
